import axios from 'axios';

const acceptPolicy = () => {
  return axios.put('alexa/settings/accept');
};

export { acceptPolicy };
